import React from "react";
import { Route, withRouter } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import logo from "./logo.svg";
import "./App.css";
// import AdminDashboard from "./screens/layout/admin-dashboard";
import UserList from "./pages/usersview";
import UserProfile from "./pages/userdetails";
import UserAdd from "./pages/createusers";

import Login from "./screens/login/login";
import FolderCopy from "./pages/folder-copy";
import Home from "./pages/home";

// Master
import MastersList from "./pages/masters-list";
import RoleList from "./pages/roles-list";
import RoleAdd from "./pages/roles-add";
import RoleProfile from "./pages/roles-profile";
import AutoNumberList from "./pages/auto-numbering-list";
import AutoNumberingProfile from "./pages/auto-numbering-profile";
import MessageConfigurationList from "./pages/messageConfiguration-list";
import MessageConfigurationProfile from "./pages/messageConfiguration-profile";
import GenericMasterAdd from "./pages/genericmaster-add";
import GenericMasterList from "./pages/genericmaster-list";
import GenericMasterProfile from "./pages/genericmaster-profile";
import MastersProfile from "./pages/master-profile";
import StatusList from "./pages/status-list";

// profile
import ProfileEdit from "./pages/user-edit";
import Profile from "./pages/user-profile";
import ChangePassword from "./pages/change-password";

// Category
import CategoryList from "./pages/category-list";
import CategoryAdd from "./pages/category-add";
import CategoryDetail from "./pages/category-detail";

// Category Document Upload
import CategoryDocumentUploadList from "./pages/category-document-upload-list";
import CategoryDocumentUploadDetail from "./pages/category-document-upload-detail";

// Project Folder
import CategoryFolderList from "./pages/project-folder-list";
import CategoryFolderDetail from "./pages/project-folder-detail";

// Category Info View
import CategoryDetails from "./pages/category-info-view";
import CategoryAttachmentList from "./pages/category-info-attachment-list";

// mobile Info Review
import MobileInfoViewList from "./pages/mobile-view-info-list";
import MobileInfoViewDetail from "./pages/mobile-view-info-detail";

import MobileLogin from "./screens/login/Mobilelogin";
import MobileHome from "./pages/mobile-home";

//mobile Category Attachment List
import MobileInfoAttachment from "./pages/mobile-category-info-attachment-list";


// super admin
import SuperAdminList from "./pages/super-admin-list";
import SuperAdminAdd from "./pages/super-admin-add";


import SessionExpired from "./screens/Common/SessionExpired";
import MobileSessionExpired from "./screens/MobileCommon/SessionExpired";

import config from "./config";

toast.configure({
  draggable: false,
});

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <>
        {/* <AdminDashboard> */}
        <Route
          exact
          path="/"
          component={Login}
          // render={() => {
          //   window.location = config.REDIRECT_URL;
          // }}
        />
        <Route exact path="/home" component={Home} />
        <Route exact path="/change-password" component={ChangePassword} />
        <Route exact path="/user-edit" component={ProfileEdit} />
        <Route exact path="/user-profile" component={Profile} />
        <Route exact path="/users-view" component={UserList} />
        <Route exact path="/createusers" component={UserAdd} />
        <Route path="/userdetails" component={UserProfile} />
        <Route exact path="/masters-list" component={MastersList} />
        <Route exact path="/master-profile" component={MastersProfile} />
        <Route exact path="/roles-list" component={RoleList} />
        <Route exact path="/roles-add" component={RoleAdd} />
        <Route exact path="/roles-profile" component={RoleProfile} />
        <Route exact path="/auto-numbering-list" component={AutoNumberList} />
        <Route
          exact
          path="/auto-numbering-profile"
          component={AutoNumberingProfile}
        />
        <Route
          exact
          path="/messageConfiguration-list"
          component={MessageConfigurationList}
        />
        <Route
          exact
          path="/messageConfiguration-profile"
          component={MessageConfigurationProfile}
        />
        <Route exact path="/genericmaster-add" component={GenericMasterAdd} />
        <Route exact path="/genericmaster-list" component={GenericMasterList} />
        <Route
          exact
          path="/genericmaster-profile"
          component={GenericMasterProfile}
        />
        <Route exact path="/status-list" component={StatusList} />

        {/* Category Routing start */}
        <Route exact path="/category-list" component={CategoryList} />
        <Route exact path="/category-add" component={CategoryAdd} />
        <Route exact path="/category-detail" component={CategoryDetail} />
        <Route
          exact
          path="/category-document-upload-list"
          component={CategoryDocumentUploadList}
        />
        <Route
          exact
          path="/project-folder-list"
          component={CategoryFolderList}
        />
        <Route
          exact
          path="/category-document-upload-detail"
          component={CategoryDocumentUploadDetail}
        />
        <Route
          exact
          path="/project-folder-detail"
          component={CategoryFolderDetail}
        />
        <Route exact path="/category-info-view" component={CategoryDetails} />
        <Route
          exact
          path="/category-info-attachment-list"
          component={CategoryAttachmentList}
        />
        <Route exact path="/folder-copy" component={FolderCopy} />
        {/* Category routing end  */}

        {/* <AdminDashboard> */}
        <Route
          exact
          path="/mobile-login"
          component={MobileLogin}
          // render={() => {
          //   window.location = config.REDIRECT_URL;
          // }}
        />
        <Route exact path="/mobile-home" component={MobileHome} />
        <Route
          exact
          path="/mobile-view-info-list"
          component={MobileInfoViewList}
        />
        <Route
          exact
          path="/mobile-category-info-attachment-list"
          component={MobileInfoAttachment}
        />
        <Route
          exact
          path="/mobile-view-info-detail"
          component={MobileInfoViewDetail}
        />

        {/* super admin */}
        <Route exact path="/super-admin-list" component={SuperAdminList} />
        <Route exact path="/super-admin-add" component={SuperAdminAdd} />
        <Route exact path="/session-expired" component={SessionExpired} />
        <Route
          exact
          path="/mobile-session-expired"
          component={MobileSessionExpired}
        />
      </>
    );
  }
}

export default withRouter(App);
